export default {
	data(){
		return {
			tableGBoptions: { 
				options: { editar: 'Editar Orden'},
				modals: [
					{
					  modal: "Recibir",
					  icon: "check-circle",
					  title: "Recibir pedido"
					},
					{
						modal: "Abonar",
						icon: "credit-card",
						title: "Realizar abono"
					},
					{
						modal: "Entregar",
						icon: "inbox-fill",
						title: "Confirmar entrega al cliente"
					},
				]
			},

			tableGBSearch: ['datos_pacientes/name','info_orden/consecutivo'],
			
			tableGBItems: [
				{
					thead: { th: '# orden' },
					tbody: { td: ['info_orden/consecutivo'],}
				},
				{
					thead: { th: 'Paciente', sort: null, sortTable: 'datos_pacientes/name'},
					tbody: { td: ['datos_pacientes/name']}
				},
				{
					thead: { th: 'Telefonos', },
					tbody: { td: ['datos_pacientes/telefonos'],}
				},
				{
					thead: { th: 'Estado', sort: null, sortTable: 'info_orden/estado'},
					tbody: { td: ['info_orden/estado'],}
				},
				{
					thead: { th: 'Lente', },
					tbody: { td: ['datos_proveedores_lente/name'],}
				},
				{
					thead: { th: 'Montura', },
					tbody: { td: ['datos_proveedores_montura/name'],}
				},
				{
					thead: { th: 'Saldo', },
					tbody: { td: ['info_ventas/saldo'],}
				},
				{
					thead: { th: 'Orden', },
					tbody: { td: ['info_orden/id'], link: '/api/pdf/orden_venta'}
				},
			]
		}
	},
}